export default __webpack_public_path__ + "static/media/information--children--g1.84e33dd2.png";